import React, { useEffect } from "react";
import { Box, Button, RadioButton, Text } from "grommet";

export const QuizContentWithColoredBoxes = ({
  questions,
  currentQuestionIndex,
  selectedOption,
  setSelectedOption,
  selectedOptionIndex,
  setSelectedOptionIndex,
  handleNextQuestion,
  handlePreviousQuestion,
  isPaused,
  isLastQuestion,
  isFirstQuestion,
}) => {
  const currentQuestion = questions[currentQuestionIndex];

  const options = [
    { label: "1", color: "status-critical" },
    { label: "2", color: "#FF4500" },
    { label: "3", color: "status-warning" },
    { label: "4", color: "status-ok" },
    { label: "5", color: "brand" },
  ];

  const handleOptionClick = (index) => {
    setSelectedOptionIndex(index);
    if (index <= 2) {
      setSelectedOption("No");
    } else {
      setSelectedOption("Yes");
    }
  };

  // Update selectedOptionIndex based on selectedOption when component mounts or updates
  useEffect(() => {
    if (selectedOptionIndex !== null) {
      return;
    }
    if (selectedOption) {
      if (selectedOption === "No") {
        setSelectedOptionIndex(0); // Default to first "No" option
      } else if (selectedOption === "Yes") {
        setSelectedOptionIndex(3); // Default to first "Yes" option
      }
    } else {
      setSelectedOptionIndex(null);
    }
  }, [selectedOption, setSelectedOptionIndex]);

  return (
    <Box
      pad="medium"
      margin={{ horizontal: "large" }}
      background="light-1"
      round="medium"
      elevation="medium"
    >
      <Text size="xlarge" weight="bold" margin={{ bottom: "medium" }}>
        {currentQuestion.question}
      </Text>
      <Text size="medium" margin={{ bottom: "medium" }} color="brand-2">
        Please rate your confidence on a scale from 1 to 5, where 5 represents
        the highest level of confidence and 1 the lowest
      </Text>

      <Box
        direction="row"
        gap="medium"
        justify="center"
        margin={{ top: "medium" }}
      >
        {options.map((option, index) => (
          <Box key={index} width="small">
            <RadioButton
              label={option.label}
              onClick={() => handleOptionClick(index)}
              disabled={isPaused}
              checked={selectedOptionIndex === index}
              primary={selectedOptionIndex === index}
              color={option.color}
              style={{
                borderRadius: "12px",
                padding: "16px",
                fontSize: "16px",
                backgroundColor:
                  selectedOptionIndex === index ? option.color : "light-3",
                color: selectedOptionIndex === index ? "white" : "black",
                textAlign: "center",
                transition: "background-color 0.3s, transform 0.2s",
                boxShadow:
                  selectedOptionIndex === index
                    ? "0px 4px 12px rgba(0, 0, 0, 0.2)"
                    : "0px 2px 6px rgba(0, 0, 0, 0.1)",
                transform:
                  selectedOptionIndex === index ? "scale(1.05)" : "none",
                cursor: "pointer",
              }}
              hoverIndicator={{
                background: {
                  color: option.color,
                  opacity: 0.8,
                },
              }}
            />
          </Box>
        ))}
      </Box>

      <Box
        direction="row"
        justify="between" // Ensures items are placed at opposite ends
        align="center"
        pad="small"
        margin={{ top: "medium" }}
      >
        {/* Left Section: "Your Answer" */}
        <Box
          width="50%" // Adjust width as needed
          pad={{ horizontal: "small", vertical: "xsmall" }}
          align="start"
        >
          <Text size="medium">Your answer:</Text>
          <Text weight="bold" color="brand" size="large">
            {selectedOptionIndex !== null
              ? options[selectedOptionIndex]?.label
              : "Please select an answer"}
          </Text>
        </Box>
        {/* Right Section: Buttons */}
        <Box direction="row" gap="small" align="end">
          {!isFirstQuestion && (
            <Button
              label={<Text color="white">Previous question</Text>}
              primary
              onClick={handlePreviousQuestion}
              size="large"
              disabled={isPaused}
              color="status-critical" // Change the button color (Grommet theme color)
              style={{
                borderRadius: "12px",
                padding: "12px 24px",
                fontSize: "18px",
              }}
            />
          )}
          <Button
            label={
              <Text color="white">
                {isLastQuestion ? "Submit my assessment" : "Next question"}
              </Text>
            }
            primary
            onClick={handleNextQuestion}
            size="large"
            disabled={isPaused}
            color="brand"
            style={{
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "18px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
